export default __webpack_public_path__ + "static/media/ICON9.aeea1225.svg";